/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  UriageYosanAllListGetReq,
  UriageYosanListGetReq,
  UriageYosanListGetRes,
  UriageYosanListPutReq,
  UriageYosanZensyaListRes,
} from "./TUriageYosan"

/**
 * 業績会議に対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class uriageYosanService extends ConnectApi {
  /**
   * 売上予算リスト取得
   *
   * @param {UriageYosanListGetReq} params
   * @param {(param: TApiResponse<UriageYosanListGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<UriageYosanListGetRes[]>) => any} reject
   * @memberof MenuService
   */
  getUriageYosanList = async (params: UriageYosanListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<UriageYosanListGetRes[]>> =
        await this.getInner(`/budget/uriageyosan`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * 売上予算全社リスト取得
   *
   * @param {UriageYosanAllListGetReq} params
   * @param {(param: TApiResponse<UriageYosanZensyaListRes[]>) => any} resolve
   * @param {(param: TApiResponse<UriageYosanZensyaListRes[]>) => any} reject
   * @memberof MenuService
   */
  getUriageYosanZensyaList = async (params: UriageYosanAllListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<UriageYosanZensyaListRes[]>> =
        await this.getInner(`/budget/uriageyosan/zensyalist`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 売上予算リスト更新
   *
   * @param {UriageYosanListGetReq} params
   * @param {(param: TApiResponse<UriageYosanListGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<UriageYosanListGetRes[]>) => any} reject
   * @memberof MenuService
   */
  putUriageYosanList = async (params: UriageYosanListPutReq[]) => {
    try {
      const res: AxiosResponse<TApiResponse<UriageYosanListGetRes[]>> =
        await this.putInner(`/budget/uriageyosan/actions/putlist`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }
}
